module.exports = __webpack_public_path__ + "img/night-bottom-bg_ms.44225877.png";